const GrupoMMParticular1 = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PPOSCONVERGENTGRUPOMM19",
            "price": 32.9752,
            "name": "Fibra 600 Masxmenos + Ilimitadas 10 Gb",
            "operator": "GRUPO MM",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": null,
            "commercial_enrichment": null,
            "description_file": null,
            "fixed_line_info": null,
            "mobile_line_info": null,
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [],
            "promotions": [
                "PROMOGRUPO_MM",
                "PROMOGRUPOMM1",
                "PROMOGRUPOMM7",
                "PROMOGRUPO_MM3"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOGRUPO_MM3",
                "duration": 3,
                "name": "F600 a precio de F100 MM",
                "duration_unit": "month",
                "amount": "10.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "GRUPO MM"
            }
        ]
    }
]
export default GrupoMMParticular1;